<template>
  <div id="Report" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white bb1 pl5 pr5 ">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">R</span>eporte</div>
        <div class="col-3 t-r f22 pr3"> </div>
      </div>
      <div class="col-12 lh36 pl10 pr10 f14 bg-color-white uppercase">
        <div class="col-6 t-c" @click="extCh()" v-if="!$store.state.app_args.extension_name">CAJA <i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <div class="col-6 t-c" v-else><span @click="extCh()">{{$store.state.app_args.extension_name}} </span><i class="iconfont icon-error color-muted" @click="del_page_args()" ></i></div>
        <div class="col-6 t-c" @click="timeCh()">
          <span v-if="$store.state.app_args.report_date == 1">Hoy</span>
          <span v-else-if="$store.state.app_args.report_date == 2">Ayer</span>
          <span v-else-if="$store.state.app_args.report_date == 3">Esta semana</span>
          <span v-else-if="$store.state.app_args.report_date == 4">Este mes</span>
          <span v-else-if="$store.state.app_args.report_date == 5">La semana pasada</span>
          <span v-else-if="$store.state.app_args.report_date == 6">El mes pasado</span>
          <span v-else-if="$store.state.app_args.report_date == 7">últimos 7 días</span>
          <span v-else-if="$store.state.app_args.report_date == 8">últimos 30 días</span>
          <span v-else-if="$store.state.app_args.report_date == 9">últimos 90 días</span>
        <i class="iconfont icon-arrow-down-filling color-muted"></i></div>
        <!--
        <div class="col-4 t-c" :class="{'bb3-primary color-primary fw':report_type == 1,'color-muted':report_type != 1}" @click="typeCh(1)">Ventas</div>
        <div class="col-4 t-c" :class="{'bb3-primary color-primary fw':report_type == 2,'color-muted':report_type != 2}" @click="typeCh(2)">TOP</div>
        -->
      </div>
      <div class="col-12 bg-color1 pt5 pb5 pl10 pr10 f12 uppercase">
        <div class="col-6 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':$store.state.app_args.report_type == 'top','color-muted':$store.state.app_args.report_type != 'top'}" @click="typeCh('top')">
          <i class="iconfont icon-top-raning-fill f16" :class="{'color-success':$store.state.app_args.report_type == 'top','color-muted':$store.state.app_args.report_type != 'top'}"></i>
          TOP 
        </div>
        <div class="col-6 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':$store.state.app_args.report_type == 'sales','color-muted':$store.state.app_args.report_type != 'sales'}" @click="typeCh('sales')">
          <i class="iconfont icon-shujucanmou f16" :class="{'color-success':$store.state.app_args.report_type == 'sales','color-muted':$store.state.app_args.report_type != 'sales'}"></i>
          Ventas
        </div>
      </div>
      <!--
        <div class="col-2 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':time_type == 2,'color-muted':time_type != 2}" @click="timeCh(2)">AYER</div>
        <div class="col-2 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':time_type == 1,'color-muted':time_type != 1}" @click="timeCh(1)">HOY</div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':time_type == 3,'color-muted':time_type != 3}" @click="timeCh(3)">Esta semana</div>
        <div class="col-4 t-c pt8 pb8 r10 b-s-1" :class="{'bg-color-primary color-white':time_type == 5,'color-muted':time_type != 5}" @click="timeCh(5)">Mas</div>
      <div class="col-12 bg-color-white pl10 pr10 f14 uppercase color-muted lh36">
        Hoy <i class="iconfont icon-arrow-down-filling color-muted"></i> 
        Todas <i class="iconfont icon-arrow-down-filling color-muted"></i> 
      </div>
      -->
      <div class="col-12 bg-color-white fw lh32 pl5 pr10 f14 bb1" v-if="$store.state.app_args.report_type == 'top'">
        <div class="col-1 t-c fw">No.</div>
        <div class="col-7 el1 pl5">Producto</div>
        <div class="col-2 t-r">Cant.</div>
        <div class="col-2 t-r">Stock</div>
      </div>
    </div>
    <div class="col-12 pt3 pb10 bg-color1 lh44" style="overflow-y: auto;" v-if="$store.state.app_args.report_type == 'sales'"> 
      <div class="h12"></div>
      <div class="col-12 t-c f14 color-muted"> {{ time_text }}</div>
      <div class="col-12 bg-color-white color-muted">
        <div class="col-12 pl8 pr8 bb1">
          <div class="col-3">Fecha</div>
          <div class="col-9 t-r color-black"> {{ start_time_text }} <span v-if="start_time_text != end_time_text"> - {{ end_time_text }}</span></div>
        </div>
        <div class="col-12 pl8 pr8 bb1">
          <div class="col-6">Total</div>
          <div class="col-6 t-r color-black">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }} <span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(sale_detail_total_ex1,2) }}</span> <span v-else> {{ fun.formatMoney(sale_detail_total,2) }}</span> </div>
        </div>
        <div class="col-12 bg-color-white pl8 pr8 bb1">
          <div class="col-6">Ventas</div>
          <div class="col-6 t-r color-black">{{ fun.formatMoney(sales_count, 0) }}</div>
        </div>
        <div class="col-12 bg-color-white pl8 pr8 bb1">
          <div class="col-6">Ganancia</div>
          <div class="col-6 t-r color-black">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }} <span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(sale_detail_profit_ex1,2) }}</span> <span v-else>{{ fun.formatMoney(sale_detail_profit,2) }}</span></div>
        </div>
      </div>
      <div class="col-12 f14 color-muted"> <i class="iconfont icon-arrow-right-filling color-primary"></i>  Gaveta </div>
      <div class="col-12 bg-color-white color-muted">
        <div class="col-12 pl8 pr8 bb1" v-for="(payment,payment_i) in sale_payment" v-bind:key="payment_i">
          <div class="col-6">{{ payment.method_name }}</div>
          <div class="col-6 t-r color-black">{{ fun.formatMoney(payment.total) }}</div>
        </div>
      </div>
      <div class="col-12 f14 color-muted"> <i class="iconfont icon-arrow-right-filling color-primary"></i>  Cajera(o)</div>
      <div class="col-12" v-for="(sale_cashier,sale_cashier_i) in sale_cashier_select" v-bind:key="sale_cashier_i">
        <div class="col-12 bg-color-white color-muted mb5">
          <div class="col-12 pl8 pr8 bb1">
            <div class="col-12 fw">{{ sale_cashier.user_name }}</div>
          </div>
          <div class="col-12 pl8 pr8 bb1">
            <div class="col-6">Total</div>
            <div class="col-6 t-r color-black">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }} <span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(sale_cashier.total_ex1,2) }}</span> <span v-else>{{ fun.formatMoney(sale_cashier.total,2) }}</span> </div>
          </div>
          <div class="col-12 bg-color-white pl8 pr8 bb1">
            <div class="col-6">Ventas</div>
            <div class="col-6 t-r color-black">{{ fun.formatMoney(sale_cashier.sales_count, 0) }}</div>
          </div>
          <div class="col-12 pl8 pr8 bb1" v-for="(cashier_paymentr,cashier_paymentr_i) in sale_cashier.payment" v-bind:key="cashier_paymentr_i">
            <div class="col-6">{{ cashier_paymentr.method_name }}</div>
            <div class="col-6 t-r color-black">{{ fun.formatMoney(cashier_paymentr.total) }}</div>
          </div>
        </div>
      </div>
      <div class="col-12 f14 color-muted"> <i class="iconfont icon-arrow-right-filling color-primary"></i>  Vendedor</div>
      <div class="col-12" v-for="(sale_salesman,sale_salesman_i) in sale_salesman_select">
        <div class="col-12 bg-color-white color-muted mb5">
          <div class="col-12 pl8 pr8 bb1">
            <div class="col-12 fw">{{ sale_salesman.user_name }}</div>
          </div>
          <div class="col-12 pl8 pr8 bb1">
            <div class="col-6">Total</div>
            <div class="col-6 t-r color-black">{{ $store.state.currency[$store.state.pos.currency_on].currency_code }} <span v-if="$store.state.pos.currency_on == 1">{{ fun.formatMoney(sale_salesman.total_ex1,2) }}</span> <span v-else>{{ fun.formatMoney(sale_salesman.total,2) }}</span> </div>
          </div>
          <div class="col-12 bg-color-white pl8 pr8 bb1">
            <div class="col-6">Ventas</div>
            <div class="col-6 t-r color-black">{{ fun.formatMoney(sale_salesman.sales_count, 0) }}</div>
          </div>
          <div class="col-12 pl8 pr8 bb1" v-for="(salesman_paymentr,salesman_paymentr_i) in sale_salesman.payment" v-bind:key="salesman_paymentr_i">
            <div class="col-6">{{ salesman_paymentr.method_name }}</div>
            <div class="col-6 t-r color-black">{{ fun.formatMoney(salesman_paymentr.total) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 pt3 pb10 bg-color1" style="overflow-y: auto;" v-if="$store.state.app_args.report_type == 'top'"> 
      <div class="h15"></div>
      <div class="col-12 bg-color-white color-muted pl5 pr10 bb1 pt8 pb5" v-for="(detail,detail_i) in data_list" v-bind:key="detail_i" @click="warehouse_log(detail.product_id)">
        <div class="col-1 t-c fw lh48">{{ detail_i + 1 }}</div>
        <div class="col-2">
          <img v-bind:src="detail.pic" v-if="detail.pic" class="w5 h5">
          <img src="@/assets/goods.jpg" v-else class="w5">
        </div>
        <div class="col-5 el1 pl5 el2 f14 uppercase">{{ detail.product_name}}</div>
        <div class="col-2 t-r lh48">{{fun.formatMoney(detail.quantity,2,'.',',',true) }}</div>
        <div class="col-2 t-r lh48">{{fun.formatMoney(detail.qty,2,'.',',',true) }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Report',
  data () {
    return {
      data_list: [],
      report_type: 1,
      time_type: 1,
      time_text: '',
      sales_count: 0,
      sale_detail_total: 0,
      sale_detail_profit: 0,
      sale_detail_total_ex1: 0,
      sale_detail_profit_ex1: 0,
      sale_payment: [],
      sale_cashier_select: [],
      sale_salesman_select: [],
      start_time_text: '',
      end_time_text: ''
    }
  },
  created: function () {
    //this.get_sales_report();
    //this.report_type = 2;
    if(this.$store.state.app_args.report_type == 'top'){
      this.get_top();
    }else{
      this.get_sales_report();
    }
  },
  methods: {
    get_sales_report() {
      var post_data = {};
      post_data.time_type = this.$store.state.app_args.report_date;
      post_data.extension_code = this.$store.state.app_args.extension_code;
      this.post(this.api_url + 'manage/sales_report', post_data).then((res)=>{
        if(res.status == 1){
          this.time_text = res.data.time_text;
          this.sales_count = res.data.sales_count;
          this.sale_detail_total = res.data.sale_detail_total;
          this.sale_detail_profit = res.data.sale_detail_profit;
          this.sale_detail_total_ex1 = res.data.sale_detail_total_ex1;
          this.sale_detail_profit_ex1 = res.data.sale_detail_profit_ex1;
          this.sale_payment = res.data.sale_payment;
          this.sale_cashier_select = res.data.sale_cashier_select;
          this.sale_salesman_select = res.data.sale_salesman_select;
          this.start_time_text = res.data.start_time;
          this.end_time_text = res.data.end_time;
        }else{
          this.data_list = []
        }
      })
    },
    get_top(){
      var post_data = {};
      post_data.time_type = this.$store.state.app_args.report_date;
      this.post(this.api_url + 'manage/sales_top', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data.sale_detail;
        }else{
          this.data_list = []
        }
      })
    },
    /*
    timeCh(i){
      this.time_type = i;
      if(this.report_type == 1){
        this.get_sales_report();
      }else{
        this.get_top();
      }
    },
    */
    typeCh(report_type){
      this.$store.commit('setAppArgs',{report_type:report_type});
      if(report_type == 'sales'){
        this.get_sales_report();
      }else{
        this.get_top();
      }
    },
    timeCh(){
      this.$router.push({name:'M_TimeSelect'});
    },
    extCh(){
      this.$router.push({name:'M_ExtensionsSelect'});
    },
    set_user_args(i){
      let user_args = {};
      if(this.$route.query.user_type == 2){
        user_args.cashier_id = this.data_list[i].original_id
        user_args.cashier_name = this.data_list[i].user_name;
        this.$store.commit('setPageCashierArgs',user_args);
      }else{
        user_args.salesman_id = this.data_list[i].original_id;
        user_args.salesman_name = this.data_list[i].user_name;
        this.$store.commit('setPageSalesmanArgs',user_args);
      }
      this.$router.back(-1);
    },
    del_page_args(){
      this.$store.commit('setAppArgs',{extension_code: 0, extension_name: ''});
      this.get_sales_report();
    },
    //查看该产品库存历史记录
    warehouse_log(id){
      this.$router.push({name:'M_WarehouseLog',query:{product_id: id}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Report.vue